import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { SelectorCluster } from '../components/ClusterSelector/types';
import { BackstageActionsApiRef } from '../services';

const KUBERNETES_PLUGIN_ID = 'kubernetes';
const GET_RUNWAY_CLUSTERS_ACTION_NAME = 'get-runway-clusters';

function useRunwayClusters() {
  const backstageActionsApi = useApi(BackstageActionsApiRef);

  return useAsync(async (): Promise<SelectorCluster[]> => {
    const output = await backstageActionsApi.invokeBackstageAction<{ clusters?: SelectorCluster[] }>({
      pluginId: KUBERNETES_PLUGIN_ID,
      actionName: GET_RUNWAY_CLUSTERS_ACTION_NAME,
      input: {},
    });

    return output.clusters ?? [];
  }, [backstageActionsApi]);
}

export default useRunwayClusters;
